<h2 class="modal-title">Reset Your Password</h2>
<p class="modal-dec">Enter a new password to reset your account access securely.</p>
<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
        <label class="form-label">Password <span class="req">*</span></label>
        <input type="password" class="form-control" placeholder="Enter password" formControlName="password">
        @if (f['password'].invalid && f['password'].touched || submitted){
        @if(f.password.errors?.required) {
        <span class="required-message">Please enter password</span>
        }
        @if (f.password.errors?.minlength){
        <span class="required-message">Please enter at least 6 characters</span>
        }
        }
    </div>
    <div class="form-group">
        <label class="form-label">Confirm Password <span class="req">*</span></label>
        <input type="password" class="form-control" placeholder="Enter confirm password"
            formControlName="confirm_password">
        @if (f['confirm_password'].invalid && f['confirm_password'].touched || submitted){
        @if(!f.confirm_password.errors?.required && f.confirm_password.errors?.passwordNotMatch) {
        <span class="required-message">Password and confirm password does not match</span>
        }
        }
    </div>
    <div class="form-group">
        <button type="submit" class="btn btn-primary" [disabled]="resetPasswordForm.invalid">
            <span class="btn-primary-hover"></span>
            <span class="btn-content">Reset Password</span>
        </button>
    </div>
</form>
